module.exports = __webpack_public_path__ + "img/zhichu.3355d532.png";